import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`pagination__item ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({ width: 5 });
    const { updateSearch, simulateUpdateSearch } = useActions();

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <div class="pagination-wrapper">
            <nav class="pagination" role="navigation" aria-label="Paginación">
                <ul class="pagination__list list-unstyled" role="list">
                    {prev && (
                        <li>
                            <PageLink {...pageLinkProps(prev)} className="pagination__item--next pagination__item-arrow link motion-reduce" ariaLabel="Previous page">
                                <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                                </svg>
                            </PageLink>
                        </li>
                    )}

                    {first && (
                        <>
                            <li>
                                <PageLink {...pageLinkProps(first)} ariaLabel="Página 1">
                                    {first.page}
                                </PageLink>
                            </li>
                            <li><span class="pagination__item">...</span></li>
                        </>
                    )}

                    {pages.map(page => (
                        <li key={page.page}>
                            <PageLink aria-disabled={page.current} className={`${page.current ? "pagination__item--current light" : "link"}`} ariaLabel={`${page.page} page`} {...pageLinkProps(page)}>
                                {page.page}
                            </PageLink>
                        </li>
                    ))}

                    {last && (
                        <>
                            <li><span class="pagination__item">...</span></li>
                            <li>
                                <PageLink {...pageLinkProps(last)} ariaLabel={`Página ${last.page}`}>
                                    {last.page}
                                </PageLink>
                            </li>
                        </>
                    )}

                    {next && (
                        <li>
                            <PageLink {...pageLinkProps(next)} className="pagination__item--prev pagination__item-arrow link motion-reduce" ariaLabel="Next page">
                                <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                                </svg>
                            </PageLink>
                        </li>
                    )}
                </ul>
            </nav>
        </div>
    )
}